<template>
  <aside
    class="Rank d-flex"
    :class="{hide}"
    @click="hide = !hide"
    @touchstart=touchstart
    @touchmove=touchmove
    @touchend=touchend
  >
    <div class="player flex-1">
      <transition-group class="v-list" v-if="players" name="list">
        <div class="v-list-item pr-1 transition-800ms" :class="[player.team]" v-for="player in players" :key=player.rank>
          <span class="v-list-item-avatar">
            <img :src="'/static/img/' + player.avatar + '_Portrait.png'" :alt="player.name">
          </span>
          <div class="v-list-item-content">
            <div class=name>{{ player.name }}</div>
          </div>
          <div class="v-list-item-score mr-1">
            {{ player.score }}
          </div>
        </div>
      </transition-group>
    </div>
    <TeamGraph :team=team />
  </aside>
</template>

<script>
import TeamGraph from '@/components/TeamGraph'

export default {
  name: 'Rank',
  components: { TeamGraph },
  props: ['players', 'team'],
  data: () => ({
    hide: true,
    touch: {
      touched: false,
      x: null
    }
  }),
  methods: {
    touchstart (e) {
      this.touch.x = e.touches[0].clientX
      this.touch.touched = true
    },
    touchmove (e) {
      if (!this.touch.touched) return
      const x = e.touches[0].clientX

      if (x < this.touch.x - 20) {
        this.hide = false
        this.touchend()
      } else if (x > this.touch.x + 20) {
        this.hide = true
        this.touchend()
      }
    },
    touchend () {
      this.touch.touched = false
      this.touch.x = null
    }
  }
}
</script>

<style scoped>
.Rank {
  flex-direction: column;
  width: 240px;
  border-left: solid 1px #b0b0ba;
  z-index: 19;
}
.v-list-item-content>.name {
  font-size: 14px;
  font-weight: 1000;
}
.v-list-item-content>.rank,
.v-list-item-content>.team {
  color: #53535f;
  font-size: 13px;
  font-weight: 400;
}
@media screen and (max-width: 1080px) {
.Rank {
  position: fixed;
  top: 56px;
  bottom: 0;
  right: 0;
  background: white;
  transition: all .5s;
}
.Rank.hide {
  transform: translateX(calc(100% - 50px));
}
}
</style>



// WEBPACK FOOTER //
// src/components/Rank.vue